export default "__VITE_ASSET__CDZwB1WM__"